import { render, staticRenderFns } from "./SeriesFundsFinalSelection.vue?vue&type=template&id=48658180&scoped=true&"
import script from "./SeriesFundsFinalSelection.vue?vue&type=script&lang=js&"
export * from "./SeriesFundsFinalSelection.vue?vue&type=script&lang=js&"
import style0 from "./SeriesFundsFinalSelection.vue?vue&type=style&index=0&id=48658180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48658180",
  null
  
)

export default component.exports